
// ConfigContext.js
import { createContext, useContext, useState, useEffect, useMemo, React } from 'react';

const ConfigContext = createContext();

export function ConfigProvider({ children }) {
    const [configLibrary, setConfigLibrary] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                // Load config from public folder
                const response = await fetch('/config.json');
                if (!response.ok) {
                    throw new Error(`Failed to load config: ${response.status}`);
                }
                const configData = await response.json();
                setConfigLibrary(configData);
            } catch (err) {
                console.error('Error loading config:', err);

            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []); // Empty dependency array ensures this runs only once

    if (loading) {
        return <div> </div>;
      }

    // Optional: Prevent unnecessary re-renders
    const contextValue = {
        configLibrary,
    };

    return (
        <ConfigContext.Provider value={contextValue}>
            {children}
        </ConfigContext.Provider>
    );
}

export function useConfigContext() {
    const context = useContext(ConfigContext);
    if (context.loading) {
        throw new Promise(resolve => setTimeout(resolve, 100)); // Suspend
    }
    return context;
}